import { render } from "./BaseSidebarBtn.vue?vue&type=template&id=c1a57f24"
import script from "./BaseSidebarBtn.vue?vue&type=script&lang=js"
export * from "./BaseSidebarBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__